import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface YearSelectorProps {
  selectedYear: number;
  onYearChange: (year: number) => void;
  className?: string;
}

export function YearSelector({
  selectedYear,
  onYearChange,
  className = ''
}: YearSelectorProps) {
  const [showYearSelector, setShowYearSelector] = useState(false);
  const [selectorStartYear, setSelectorStartYear] = useState(Math.floor(selectedYear / 10) * 10);

  // Navegação ano a ano no controle principal
  const handlePreviousYear = () => {
    onYearChange(selectedYear - 1);
  };

  const handleNextYear = () => {
    onYearChange(selectedYear + 1);
  };

  // Navegação década a década no seletor
  const handlePreviousDecade = () => {
    setSelectorStartYear(prev => prev - 10);
  };

  const handleNextDecade = () => {
    setSelectorStartYear(prev => prev + 10);
  };

  // Seleção de ano
  const handleYearSelect = (year: number) => {
    onYearChange(year);
    setShowYearSelector(false);
  };

  // Abrir seletor
  const handleOpenSelector = () => {
    setSelectorStartYear(Math.floor(selectedYear / 10) * 10);
    setShowYearSelector(true);
  };

  if (showYearSelector) {
    const years = Array.from({ length: 10 }, (_, i) => selectorStartYear + i);
    
    return (
      <div className={`space-y-4 ${className}`}>
        {/* Navegação de Década */}
        <div className="flex items-center justify-center gap-2 mb-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={handlePreviousDecade}
            className="h-8 px-2 rounded-full border border-border hover:bg-accent hover:border-accent"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          
          <div className="text-base font-semibold text-foreground min-w-[100px] text-center">
            {selectorStartYear} - {selectorStartYear + 9}
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={handleNextDecade}
            className="h-8 px-2 rounded-full border border-border hover:bg-accent hover:border-accent"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>

        {/* Linha Horizontal de Anos */}
        <div className="flex items-center justify-center gap-1 flex-wrap">
          {years.map((year) => {
            const isSelected = year === selectedYear;
            return (
              <Button
                key={year}
                variant="ghost"
                onClick={() => handleYearSelect(year)}
                className={`
                  h-8 px-3 text-sm rounded-full font-medium transition-all border
                  ${isSelected 
                    ? 'bg-primary text-primary-foreground border-primary' 
                    : 'border-border text-foreground hover:bg-accent hover:border-accent'
                  }
                `}
              >
                {year}
              </Button>
            );
          })}
        </div>

        {/* Botão Fechar */}
        <div className="flex justify-center">
          <Button
            variant="ghost"
            onClick={() => setShowYearSelector(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            Fechar
          </Button>
        </div>
      </div>
    );
  }

  // Controle Principal
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`}>
      <Button
        variant="ghost"
        size="sm"
        onClick={handlePreviousYear}
        className="h-10 w-10 p-0 rounded-full border border-border hover:bg-accent hover:border-accent"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      
      <button
        onClick={handleOpenSelector}
        className="text-base font-semibold text-center min-w-[160px] h-10 px-4 rounded-full border border-border hover:bg-accent hover:border-accent hover:text-accent-foreground transition-all cursor-pointer"
      >
        {selectedYear}
      </button>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={handleNextYear}
        className="h-10 w-10 p-0 rounded-full border border-border hover:bg-accent hover:border-accent"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}